import { apiClient, type DcEntity, type PageEntity } from '@/libs/api'
import { type DcsListRequestQuery } from '@/libs/api/types'

export type FetchDcsQuery = {
  page?: number
  tenantKey: string
  query?: DcsListRequestQuery
}

export type FetchDcsResponse = {
  data: DcEntity[]
  pagination: PageEntity | null
}

export const fetchDcs = async (
  { tenantKey, query }: FetchDcsQuery,
  signal?: AbortSignal
): Promise<FetchDcsResponse> => {
  const { data, pagination } = await apiClient._tenant(tenantKey).dcs.$get({
    query,
    config: {
      signal
    }
  })
  return {
    data,
    pagination
  }
}
